import { useQuery, useQueryClient, UseQueryResult } from "@tanstack/react-query"
import ResponseError from "../../../types/responseError"
import { carrotClient } from "#/utils/CarrotClient"
import { MemberUserCountry } from "#/lib/carrot-api/types/MemberUserCountry"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"

const ENDPOINT = "GetMemberCountry"

const getBenefitCacheKey = (): (string | number)[] => [ENDPOINT]

export default function useGetMemberCountry(): UseQueryResult<MemberUserCountry, ResponseError> {
  return useQuery<MemberUserCountry, ResponseError>(getBenefitCacheKey(), () => carrotClient.getMemberUserCountry(), {
    retry: buildCarrotApiRetryPolicy(3)
  })
}

export function useCreateCountryOverride(): (attributes: MemberUserCountry) => void {
  const queryClient = useQueryClient()
  return (attributes: MemberUserCountry) => {
    queryClient.setQueryDefaults(getBenefitCacheKey(), { staleTime: Infinity, cacheTime: Infinity })
    queryClient.setQueryData(getBenefitCacheKey(), attributes)
  }
}
